var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.764 3h-3.157v12.26c0 1.462-1.214 2.662-2.725 2.662s-2.725-1.2-2.725-2.661c0-1.435 1.187-2.609 2.644-2.661V9.522C6.591 9.574 4 12.104 4 15.26 4 18.444 6.644 21 9.909 21s5.909-2.583 5.909-5.74V8.975A7.5 7.5 0 0 0 20 10.33V7.252C17.626 7.174 15.764 5.296 15.764 3"
})));
export default SvgTiktok;